<template>
    <div style="padding-top: 40px;">
       <!-- currently used in admin login -->
      <div v-if="!forgotP">
          <ion-card class="ion-padding">
            <!-- <div v-if="basicSettings != null" class="logo"> -->
              <!-- <img  src="../../frontend/views/logo.png" > -->
              <!-- <img  :src="basicSettings.ImageUrl" > -->
            <!-- </div> -->
            <ion-item style="--border-style: none;">
              <ion-input class="input-style" type="email" name="email" :placeholder="$t('backoffice.form.fields.email')"
              @input="email = $event.target.value" 
              v-bind:value="email">
              </ion-input>
            </ion-item>
            <!-- <ion-item style="--border-style: none;">
              <ion-input class="input-style" type="password" name="password" :placeholder="$t('backoffice.form.fields.password')"
              @input="password = $event.target.value" 
              v-bind:value="password">
              </ion-input>
            </ion-item> -->
            <ion-item class="password-container">
              <ion-input class="input-style" :type="showPassword ? 'text' : 'password'" name="password" :placeholder="$t('backoffice.form.fields.password')"
                @input="password = $event.target.value" v-bind:value="password"></ion-input>
              <ion-icon class="password-icon iconify" :name="showPassword ? 'eye' : 'eye'" @click="toggleShowPassword()">
              </ion-icon>
            </ion-item>
                <ion-button expand="block" shape="round" :disabled="loginButtonPush" color="primary" @click="login">{{$t('backoffice.form.login')}}</ion-button>
            <ion-item>
                <a class="forgotPass" @click="forgotPassword()">{{$t('backoffice.options.forgotPassword')}}</a>
            </ion-item>
            <div v-if="spinner">
                <ion-progress-bar  color="primary" type="indeterminate" reversed="true"></ion-progress-bar>
            </div>
          </ion-card> 
      </div>
      <div v-else>
          <ion-card>
              <ion-item>
                <ion-input type="email" name="forgotEmail" :placeholder="$t('backoffice.form.fields.email')"
                @input="forgotEmail = $event.target.value" 
                v-bind:value="forgotEmail">
                </ion-input>
              </ion-item>
              <ion-button :disabled="forgotEmail === ''" expand="full" color="primary" @click="sendNewPass()">{{$t('backoffice.options.sendNewPassword')}}</ion-button>
              <ion-item>
              <a class="forgotPass" @click="back()">Back</a>
              </ion-item>
              <div v-if="spinner">
                  <ion-progress-bar  color="primary" type="indeterminate" reversed="true"></ion-progress-bar>
              </div>
          </ion-card>
      </div>

    </div>
</template>

<script>

import { Api } from '../api/api.js';
import { EventBus } from '../../frontend/event-bus';
import {Commons} from "@/frontend/commons";
  

export default {

  name: 'userForm',
   
  props: {
      createdRestaurantEmail: { type: String, default: '' },
  },

  data () {
    return {
      email: '',
      password: '',
      showPassword: false,
      userLogin: null,

      indexUserIsLogin: -1,

      forgotP: false,
      forgotEmail: '',
      // basicSettings: null,
      spinner: false,

      loginButtonPush: false, 

    }
  },
  created: function(){
    if(this.createdRestaurantEmail !== '')
      this.email = this.createdRestaurantEmail;  
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
     async getAllRestaurant(){
        await  Api.fetchAll('Restaurant').then(async response => {
              if(response.status === 200){
                let restaurants = response.data
                  let myRestaurants = this.$store.state.user.AllRestaurant

                  let userRestaurant = []
                  restaurants.forEach(restaurant => {
                      if (myRestaurants.indexOf(restaurant._id) != -1)
                          userRestaurant.push(restaurant)
                  });
                  EventBus.$emit('userRestaurant', userRestaurant)
              }
          })
          .catch(e => {
              e
          });
      },
      forgotPassword(){
          this.forgotP = true;
      },
      back(){
          this.forgotP = false;
      },
      sendNewPass(){
          this.spinner = true
          if (this.forgotEmail === "")
          {
              this.ShowMessage(this.$t('backoffice.form.validate.validate'), this.$t('backoffice.form.validate.email'), this.$t('backoffice.options.sendNewPassword'));
              return;
          }
          let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
          if (emailRegex.test(this.forgotEmail) == false)
          {
              this.ShowMessage(this.$t('backoffice.form.validate.validate'), this.$t('backoffice.form.validate.emailIncorrect'), this.$t('backoffice.options.sendNewPassword'));
              return
          }
          const item = {
              "Email": this.forgotEmail,
              // "subject": "Change Password",
          }
          Api.loginForgot(item)
          .then(() => {
              this.ShowMessage(this.$t('backoffice.list.messages.infoDeleteSuccess'), this.$t('backoffice.list.messages.newPasswordSent'), this.$t('backoffice.options.login'))

              this.forgotEmail = ''
              this.forgotP = false
              this.spinner = false
          })
          .catch(e => {
              e
              this.ShowMessage(this.$t('backoffice.list.messages.infoDeleteSuccess'), this.$t('backoffice.form.validate.emailDontExist'), this.$t('backoffice.options.login'))
              this.spinner = false
          })
      },
      ShowMessage(type, message, topic='') {
        return this.$ionic.alertController
          .create({
            cssClass: 'my-custom-class',
            header: type,
            subHeader: topic,
            message: message,
            buttons: ['OK'],
          })
        .then(a => a.present())
      },

      login: async function(){
         
          if (this.email == ""){
              this.ShowMessage(this.$t('backoffice.form.validate.validate'), this.$t('backoffice.form.validate.email'), this.$t('backoffice.options.login'));
              this.loginButtonPush = false;
              return;
          }
          if (this.password == ""){
              this.ShowMessage(this.$t('backoffice.form.validate.validate'), this.$t('backoffice.form.validate.password'), this.$t('backoffice.options.login'));
              this.loginButtonPush = false;
              return;
          }
          //Comienza el login
          const item = {"Email": this.email,"Password": this.password}
          
          this.loginButtonPush = true
          this.spinner = true

          await Api.login(item).then(async response => {
            const restaurants = await Api.fetchAll('Restaurant')
            //console.log("RESTT", restaurants.data)

            const userRestaurantIds = response.data.AllRestaurant;
            const filteredRestaurants = restaurants.data.filter(restaurant => 
                userRestaurantIds.includes(restaurant._id)
            );
            //console.log("Filtered Restaurants", filteredRestaurants);

            const currentDate = new Date();
            const expiredRestaurants = filteredRestaurants.filter(restaurant => 
              restaurant?.IsForTest && restaurant?.DateTestTo && new Date(restaurant?.DateTestTo) < currentDate
            );

            if (expiredRestaurants.length > 0 && response?.data?.IsSupport == false) {
                this.ShowMessage(this.$t('frontend.app.trialExpired'),this.$t('frontend.app.trialMessageExpired'))
                //this.ShowMessage('Su fecha de prueba expiró', 'No puede ingresar.', this.$t('backoffice.options.login'));
                this.loginButtonPush = false;
                this.spinner = false;
                return;
            }

            const {Commons} = require('../../frontend/commons');
            this.userLogin = response.data;   
            //console.log(this.userLogin)  
            Api.setTokenId(this.userLogin.token);       
            
            EventBus.$emit('staffName', this.userLogin.FirstName + ' ' + this.userLogin.LastName)            
            this.$store.commit('setStaffName',this.userLogin.FirstName + ' ' + this.userLogin.LastName) ; 
               
            this.$store.commit('setIsMerchant', true) ; 
            
            const userRestaurant = await Commons.backOfficeLogin(this.userLogin);    
            EventBus.$emit('userRestaurant', userRestaurant);       
            document.querySelector('ion-menu-controller').close('end')
            this.$store.commit("setAuthentication", true);   
            
            await this.getAllRestaurant();
            EventBus.$emit('blockScreen', true);

            this.spinner = false
            this.loginButtonPush = false
          
            this.$router.push({
                name: 'ControlPanel',
                params: {
                    'firstLogin': true,
                }
            });
          })
          .catch(e => {
            e
            this.ShowMessage(this.$t('backoffice.list.messages.infoDeleteSuccess'), this.$t('backoffice.list.messages.emailOrPasswordIncorrect'), this.$t('backoffice.options.login'));
            this.loginButtonPush = false
            this.spinner = false
          });

      },


  },

}
    
</script>

<style>
 .password-container {
    position: relative;
    width: 100%;
  }

  .password-icon {
    position: absolute;
    z-index:999!important;
    top: 55%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .border-style{
    border-style:none!important;
  }

    div.logo{
      text-align: center;
      text-align: -webkit-center;
      margin: 30px 0px 30px 0px;
    }

    div.logo img{
      width:50%;
    }

    .forgotPass{
      cursor: pointer;
      font-size: 13px;
    }

</style>